import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class SEODescriptionService {
    public static readonly $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public GetAll(query) {
        return this.baseApiFactory.getData<object[]>('/api/SEODescription', query);
    }

    public Insert(values) {
        return this.baseApiFactory.post('/api/SEODescription', values);
    }

    public Update(value) {
        return this.baseApiFactory.put('/api/SEODescription', value);
    }

    public Delete(id) {
        return this.baseApiFactory.delete(`/api/SEODescription/${id}`);
    }

    public Generate(value) {
        return this.baseApiFactory.post('/api/SEODescription/Generate', value);
    }

    public GetGenerateProgress() {
        return this.baseApiFactory.get<any>('/api/SEODescription/GetGenerateProgress');
    }

    public StopGenerateProgress() {
        return this.baseApiFactory.post('/api/SEODescription/StopGenerateProgress', {});
    }
}

lazyRegister.service('SEODescriptionService', SEODescriptionService);

